import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import BookingForm from '../components/booking/BookingForm';
import './BookingPage.css';

const BookingPage = () => (
  <>
    <Helmet>
      <title>Book Appointment - Automotive Care</title>
      <meta name="description" content="Book your car service appointment online with Automotive Care." />
    </Helmet>

    <section className="page-header">
      <div className="container">
        <h1>Book Your Appointment</h1>
        <p>Fill out the form below and we&apos;ll contact you to confirm your booking.</p>
      </div>
    </section>

    <section className="section">
      <div className="container">
        <motion.div
          className="booking-form-container"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <BookingForm />
        </motion.div>
      </div>
    </section>
  </>
);

export default BookingPage;
